<div class="max-w-4xl mx-auto">
  <!-- Header -->
  <div class="flex justify-between items-center mb-10">
    <h2 class="text-4xl font-bold text-gray-800">Employee Details</h2>
    @if (isAdmin()) {
      <div class="flex gap-3">
        <button
          routerLink="edit"
          class="bg-yellow-400 hover:bg-yellow-500 text-white px-6 py-2 rounded-lg text-lg font-semibold transition"
        >
          Edit
        </button>
        <button
          class="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg text-lg font-semibold transition"
          (click)="onDelete()"
        >
          Delete
        </button>
      </div>
    }
  </div>

  <!-- Card -->
  <div class="bg-white rounded-2xl shadow-lg p-10 space-y-6">
    <!-- Rowed fields -->
    <div class="grid grid-cols-2 gap-x-8 gap-y-5">
      <div>
        <div class="text-xl font-bold text-gray-700">ID:</div>
        <div class="text-xl text-gray-700">{{ employee()?.id }}</div>
      </div>
      <div>
        <div class="text-xl font-bold text-gray-700">First Name:</div>
        <div class="text-xl text-gray-700">{{ employee()?.firstName }}</div>
      </div>
      <div>
        <div class="text-xl font-bold text-gray-700">Last Name:</div>
        <div class="text-xl text-gray-700">{{ employee()?.lastName }}</div>
      </div>
      <div>
        <div class="text-xl font-bold text-gray-700">Status:</div>
        <div
          class="text-xl text-gray-700"
          [ngClass]="{
            'text-green-600 font-semibold':
              employee()?.status?.toString() === 'ACTIVE',
            'text-red-600 font-semibold':
              employee()?.status?.toString() !== 'ACTIVE',
          }"
        >
          {{ employee()?.status }}
        </div>
      </div>
      <div>
        <div class="text-xl font-bold text-gray-700">Email:</div>
        <div class="text-xl text-gray-700 break-words">
          {{ employee()?.email }}
        </div>
      </div>
      <div>
        <div class="text-xl font-bold text-gray-700">Phone:</div>
        <div class="text-xl text-gray-700">{{ employee()?.phone }}</div>
      </div>
      <div>
        <div class="text-xl font-bold text-gray-700">Join Date:</div>
        <div class="text-xl text-gray-700">
          {{ employee()?.joinDate | date }}
        </div>
      </div>
      <div>
        <div class="text-xl font-bold text-gray-700">Department:</div>
        <a
          [routerLink]="['/department', employee()?.department?.id]"
          class="text-xl text-blue-600 hover:underline font-medium"
        >
          {{ employee()?.department?.name }}
        </a>
      </div>

      @if (employee()?.manager?.firstName) {
        <div>
          <div class="text-xl font-bold text-gray-700">Manager:</div>
          <a
            [routerLink]="['/employee', employee()?.manager?.id]"
            class="text-xl text-blue-600 hover:underline font-medium"
          >
            {{
              `${employee()?.manager?.firstName} ${employee()?.manager?.lastName}`
            }}
          </a>
        </div>
      }
    </div>

    <app-org-chart
      [orgChart]="orgChart()"
      [loading]="loadingOrgChart"
      (loadMore)="loadMoreSubordinates()"
    />
  </div>

  <!-- Back button -->
  <button
    routerLink="/employee"
    class="mt-8 bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg text-lg font-semibold transition"
  >
    Back to employees
  </button>
</div>

<!-- Delete Modal -->
<app-delete-confirmation-modal
  [show]="showDeleteDialog"
  (confirmEvent)="onConfirm()"
  (cancelEvent)="onCancel()"
/>
